var _defs, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 829.99 806.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffbb07;}.cls-3{fill:#080403;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.09,153.84a80.41,80.41,0,1,1-56.71,23.55A80.27,80.27,0,0,1,301.09,153.84Zm0-80.25A160.42,160.42,0,1,0,362.52,85.8a160.5,160.5,0,0,0-61.43-12.21Z",
    transform: "translate(-65.2 -73.59)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.74,880.4H466.48V679.69a160.52,160.52,0,0,0-321,0V880.14H65.2V679.69a240.77,240.77,0,0,1,481.54,0Z",
    transform: "translate(-65.2 -73.59)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.85,469.87a240.37,240.37,0,0,0-358.65,210V880.27H146V679.82A160.12,160.12,0,0,1,379.29,537,325.07,325.07,0,0,1,423.85,469.87Z",
    transform: "translate(-65.2 -73.59)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 526.99,
    y: 11.01,
    width: 302.99,
    height: 75.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 526.99,
    y: 147.35,
    width: 302.99,
    height: 75.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 526.99,
    y: 276.13,
    width: 302.99,
    height: 75.75
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 526.99,
    y: 11.01,
    width: 75.75,
    height: 75.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.cbead99d7b548aa7bc2d8e3aa2465033.svg";
export { ForwardRef as ReactComponent };